var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('NetWorkChartWindow'),_c('CompanyRiskLookup')],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }